<div class="todo-tab-block">
    <!-- <p class="text-14-400 color-8 mb-0 ri-py-2 ri-px-4 text-center bg-26">{{ ss.t('trash_itemEraseContent') }}</p> -->
    <div class="todo-trash-block ri-px-4 ri-pt-4 ri-bb-1 entity-block" *ngFor="let entity of deletedTodos(); let i = index; trackBy: trackByEntity;">
        <div class="" role="button" (click)="openTodoEntities(entity.entityId, entity.isRepeated)">
            <app-todo-block [entry]="entity.entityEntry" [show]="show" [clickable]="false" [hideStatus]="entity.isRepeated === true" [dateString]="entity.isRepeated ? null : (getTodo(entity.entityId).startDate || null)"></app-todo-block>
            <p class="text-14-400 color-35 mb-0 ri-pt-2" *ngIf="entity.isRepeated">{{ ss.t('trash_entryCount', { count:
                entity.entries.length.toString() }) }}</p>
        </div>
        <div class="flex items-center justify-around ri-pt-1">
            <button class="btn-text text-16-400 color-11 ri-px-8 ri-py-4" (click)="removeTodo(entity.entityId)">{{
                ss.t('common_buttonRemove') }}</button>
            <button class="btn-text text-14-400 color-35 ri-px-8 ri-py-4" (click)="restoreTodo(entity.entityId)">{{
                ss.t('common_restore') }}</button>
        </div>
    </div>

    <div class="no-result-block h-full flex items-center justify-center flex-col" *ngIf="deletedTodos().length === 0">
        <app-svg [name]="'planPlaceholder'" [color]="ss.theme().color1"></app-svg>
        <p class="text-16-400 color-8 mb-0 ri-pt-4">{{ ss.t('common_todoEmptyScreenContent') }}</p>
    </div>
</div>